var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-pie-chart-container"},[_c('Doughnut',{ref:"bar-chart",staticClass:"widget-pie-chart",attrs:{"chart-data":_vm.localChartData,"chartOptions":_vm.chartOptions,"plugins":[_vm.DoughnutCenterText]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }